// Libs
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Container } from 'react-bootstrap';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import EmailTypeService from 'services/EmailTypeService';

// Components
import Loader from 'components/common/Loader';
import PageHeader from 'components/common/PageHeader';
import EditEmailTypeModal from 'components/admin/email-types/EditEmailTypeModal';

//-------------------------------------------------------------------------------------------------------------------

class EmailTypesPage extends React.Component {

    constructor(props) {
        super(props);

        this.editEmailTypeModalRef = React.createRef();

        this.requestID = 1;
        this.state = {
            isLoading: true
        };
    }
    
    async componentDidMount() {
        window.scrollTo(0, 0);
        this.load();
    }

    async load() {
        GlobalStateService.setValues({
            area: 'email-types'
        });
        const emailTypes = await EmailTypeService.list();
        this.setState({
            emailTypes,
            isLoading: false
        });
    }

    async editEmailType(emailType) {
        await this.editEmailTypeModalRef.current.show({
            id: emailType.id
        });
        this.load();
    }

    render() {
        return (<>
            <div className="page email-types-page">

                <PageHeader>
                    <h1>Email types</h1>
                </PageHeader>

                <main>

                    <Container>
                        
                        <section>

                            {this.renderInner()}

                        </section>

                    </Container>

                </main>

            </div>

            <EditEmailTypeModal ref={this.editEmailTypeModalRef} />

        </>);
    }

    renderInner() {
        const {
            isLoading,
            emailTypes
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        return (

            <div className="sticky-table-container scrolling">

                <table className="table table-bordered sticky-table selectable email-types-table">
                    <thead>
                        <tr>
                            <th className="name-column">Name</th>
                            <th className="description-column">Description</th>
                            <th className="default-recipients-column">Default recipients</th>
                            <th className="is-enabled-column">Enabled</th>
                        </tr>
                    </thead>
                    <tbody>
                        {emailTypes.map(et =>
                            <tr key={et.id} onClick={e => this.editEmailType(et)} className={et.isEnabled ? '' : 'email-type-disabled'}>
                                <td className="name-column">{et.name}</td>
                                <td className="description-column">{et.description}</td>
                                <td className="default-recipients-column">{et.defaultRecipients}</td>
                                <td className="is-enabled-column">{et.isEnabled ? <span className="fa fa-check" /> : <></>}</td>
                            </tr>
                        )}
                    </tbody>
                </table>

            </div>

        );
    }
}

export default withRouter(EmailTypesPage);